import { useEffect, useState } from 'react';
import { subscriptionApi } from '../admin/components/subscriptionApi';

// Session-level cache - the plan menus are fetched once, not per module.
let planCache = null;

/**
 * The SAME visibility rule the sidebar uses today:
 *   visible = hasKey(menuKey) && planAllowed(menuKey)
 * hasKey     -> the user's own UserMenuPermission (sessionStorage.permissions)
 * planAllowed-> their subscription plan / add-ons (trial = all menus)
 */
export default function useMenuAccess() {
  const [planAccess, setPlanAccess] = useState(planCache);

  useEffect(() => {
    if (planCache) return;
    const company = JSON.parse(sessionStorage.getItem('companyDetails') || '{}');
    if (!company?.id) {
      planCache = { allMenus: true };
      setPlanAccess(planCache);
      return;
    }
    subscriptionApi
      .getCompanyMenus(company.id)
      .then((r) => {
        planCache = r?.data || { allMenus: true };
        setPlanAccess(planCache);
      })
      .catch(() => {
        planCache = { allMenus: true }; // fail open - never lock staff out
        setPlanAccess(planCache);
      });
  }, []);

  let keys;
  try {
    const raw = JSON.parse(sessionStorage.getItem('permissions') || '[]');
    keys = new Set((Array.isArray(raw) ? raw : []).map((p) => p.menuKey));
  } catch {
    keys = new Set();
  }

  const hasKey = (k) => keys.has(k);
  const planAllowed = (k) =>
    !planAccess || planAccess.allMenus || (planAccess.menuKeys || []).includes(k);

  return { hasKey, planAllowed, ready: !!planAccess };
}